import React, { Component } from 'react'
import axios from 'axios'
import { authenticatedUserStore } from '../stores'
import Unauthorized from '../routes/Unauthorized'

export default function withAuth(ComponentToProtect) {
    return class extends Component {
        constructor(props, context) {
            super(props, context)
            this.state = {
                loading: true,
                authorized: true,
            }
        }

        componentDidMount() {
            if (authenticatedUserStore.authToken) {
                if (this.state.loading) {
                    this.setState({ loading: false })
                }
                return
            }

            axios.get('/sso-login').then(res => {
                const { token } = res.data
                if (!token) {
                    window.location.href = '/sso-login'
                    return
                }

                authenticatedUserStore.setAuthToken(res.data.token)
                if (res.data.user) {
                    const { firstName, lastName, email, username } =
                        res.data.user
                    authenticatedUserStore.setUserData({
                        firstName,
                        lastName,
                        email,
                        username,
                    })
                    this.setState({ loading: false })
                }
                if (res.data.permissions) {
                    if (res.data.permissions.length === 0) {
                        this.setState({ authorized: false })
                    } else {
                        authenticatedUserStore.setPermissions(
                            res.data.permissions
                        )
                    }
                }
            })
        }
        render() {
            const { loading, authorized } = this.state
            if (loading) {
                return null
            }
            if (!authorized) {
                return <Unauthorized />
            }
            return <ComponentToProtect {...this.props} />
        }
    }
}
